import React, { useEffect, useState } from 'react'
import Slider from "react-slick";
import * as S from './styled'

var decode = require('unescape');

const HomeBanner = ({data}) => {

  const arrLink = []
  const imgMobile = []
  const imgDesktop = []
  const arrAlt = []

  const isMobile = screen => {
    return screen ? screen.width < 768 : false
  }

  const screen = typeof window !== `undefined` ? window.screen : false
  const [mobileDevice, setMobileDevice] = useState(false)

  const handleTag = (eventLabel) => {
      if (window && window.dataLayer)
          window.dataLayer.push({
          'event': 'institucional_home',
          'action': 'clicou_banner-principal',
          'clique': eventLabel
      })
  }

  useEffect(() => {
    if (isMobile(screen)) {
      setMobileDevice(true)
    }
  }, [screen])


  const settings = {
    dots: true,
    autoplay: true,
    infinite: true,
    autoplaySpeed: 10000,
    speed: 500,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    dotsClass: "slick-dots customDots",
    appendDots: dots => (
      <div >
        <ul data-testid="botoes-carousel-ul" style={{ margin: "0px" }}> {dots} </ul>
      </div>
    ),
    customPaging: i => (
      <div className="ft-slick__dots--custom" data-testid="dots-custom-div">
        <div className="loading" />
      </div>
    )
  };

    const newData = data && data.allWordpressAcfGatsbyPage.nodes.filter(el => el.acf.banner_1_group !== null)

    newData ? Object.entries(newData[0].acf.banner_1_group).forEach(([key, val]) => {
        key.startsWith('alt_imagem_') ? arrAlt.push(val) : null
        val.url && arrLink.push(val.url)
        val.localFile ? val.localFile.childImageSharp.fluid.aspectRatio <= 1.5 && imgMobile.push(val.localFile.childImageSharp.fluid) : null
        val.localFile ? val.localFile.childImageSharp.fluid.aspectRatio > 1.5 && imgDesktop.push(val.localFile.childImageSharp.fluid) : null
    }) : null

  return (
    <S.HomeBanner data-testid="bannerCarousel">
    <Slider {...settings} >
      {arrLink && arrLink.map((x, i) => {

        return (
          <S.Moldura data-testid={'Moldura-div-' + i} key={i} onClick={() => handleTag(arrLink[i])}>
            <a href={decode(arrLink[i])}
              data-item-text={arrAlt[i]}
              data-item-position="Banner Hero"
              data-current-service="Home"
            >
            <S.Banner1
              fluid={mobileDevice ? imgMobile[i] : imgDesktop[i]}
              data-testid={'Banner-Img-' + i}
              alt={arrAlt[i]}

            />
            </a>
          </S.Moldura>
        )
      })}
    </Slider>
  </S.HomeBanner>
  )
}


export default HomeBanner
